import { LitElement, html, css, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { tokens } from '../styles/tokens';
import { shared } from '../styles/shared';
import { icon } from '../icons';
import type { SarahTest } from '../types';

@customElement('sarah-box-test')
export class SarahBoxTest extends LitElement {
  static styles = [
    tokens,
    shared,
    css`
      :host { display: block; }

      .box-resa-bis {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        align-items: stretch;
        font-size: 14px;
        box-shadow: 0 1px 3px rgba(0,0,0,.17), 0 1px 2px rgba(0,0,0,.17);
        background-color: #fff;
        border-radius: 2px;
        margin: 0 auto 10px;
        width: 100%;
        border: 1px solid #a7a7a7;
        border-top-width: 3px;
        cursor: pointer;
        transition: transform .15s ease, box-shadow .15s ease;
      }
      .box-resa-bis:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0,0,0,.18), 0 2px 4px rgba(0,0,0,.12);
      }
      .box-resa-bis:focus-visible {
        outline: 2px solid var(--sarah-bleu);
        outline-offset: 2px;
      }
      .box-resa-bis.best-price { border-color: var(--sarah-bleu); }
      .box-resa-bis.best-price .box__action { background-color: var(--sarah-bleu); }
      .box-resa-bis.three-last { border-color: var(--sarah-rose); }
      .box-resa-bis.three-last .box__action { background-color: var(--sarah-rose); }
      .box-resa-bis.complet * { opacity: .7; }
      .box-resa-bis.complet .box__action { background-color: var(--sarah-bleu); }

      .box-resa-bis.pulsing .box__action {
        animation: actionPulse .35s ease;
      }
      @keyframes actionPulse {
        0%   { transform: scale(1); }
        50%  { transform: scale(1.06); }
        100% { transform: scale(1); }
      }
      @media (prefers-reduced-motion: reduce) {
        .box-resa-bis { transition: none; }
        .box-resa-bis:hover { transform: none; }
        .box-resa-bis.pulsing .box__action { animation: none; }
      }

      .c1 { flex: 0 0 20%; max-width: 20%; }
      .c2 { flex: 0 0 62%; max-width: 62%; }
      .c4 { flex: 1; }

      .box__date-dept {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 10px 0;
      }
      .box__date {
        font-size: 15px;
        color: var(--sarah-bleu);
        font-weight: 700;
        padding: 0 10px 10px;
        margin: 0;
      }
      .box__date span { display: block; }
      .box__dept {
        position: relative;
        text-align: center;
        flex: 1;
        font-weight: 700;
        font-size: 12px;
        color: var(--sarah-rose);
        padding-left: 40px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 25px;
      }
      .box__dept-num {
        position: absolute;
        left: 0;
        width: 30px;
        height: 25px;
        text-align: center;
        background: #424649;
        color: #fff;
        line-height: 25px;
      }
      .box__dept-num::before {
        content: "";
        position: absolute;
        right: -8px;
        top: 0;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 12.5px 0 12.5px 8px;
        border-color: transparent transparent transparent #424649;
      }
      .box__dept-ville {
        font-weight: 800;
        text-transform: uppercase;
        padding-right: 5px;
      }

      .box__address-text {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
        align-content: space-between;
        padding: 10px;
        position: relative;
      }
      .box__address {
        flex: 0 0 79%;
        font-size: 16px;
        font-weight: 700;
        color: #424649;
        order: 1;
      }
      .box__tarif {
        flex: 1 0 20%;
        text-align: right;
        order: 2;
      }
      .box__tarif .apartir { display: block; color: var(--sarah-bleu); font-size: 13px; }
      .box__tarif .prix { font-size: 20px; color: var(--sarah-rose); font-weight: 700; }
      .box__tarif .prix s { font-size: 16px; color: #999; }
      .box__text {
        flex: 0 0 63%;
        order: 3;
        margin-top: 6px;
      }
      .box__text span {
        display: flex;
        align-items: center;
        font-size: 12px;
        font-weight: 700;
      }
      .box__text .state { color: #b30000; }
      .box__text .free-cancel { color: #2c7e0c; margin-left: 12px; }
      .box__text .ic {
        width: 16px;
        height: 16px;
        margin-right: 5px;
        flex-shrink: 0;
      }
      .box__tarif-barre {
        flex: 0 0 37%;
        order: 4;
        font-size: 12px;
        text-align: right;
        color: var(--sarah-bleu);
      }
      .box__tarif-barre a { color: inherit; text-decoration: underline; }

      .box__action {
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--sarah-bleu);
        color: #fff;
      }
      .box__action button {
        color: #fff;
        background: transparent;
        border: 0;
        cursor: pointer;
        text-decoration: none;
        text-align: center;
        padding: 14px 12px;
        font: inherit;
        display: inline-flex;
        align-items: center;
        gap: 8px;
        width: 100%;
        justify-content: center;
      }
      .box__action .ic {
        width: 22px;
        height: 22px;
        display: inline-flex;
        flex-shrink: 0;
      }
      .box__action span { font-weight: 600; line-height: 1; font-size: 14px; }

      @media (max-width: 719px) {
        .c1 { flex: 0 0 45%; max-width: 45%; }
        .c2 { flex: 0 0 55%; max-width: 55%; }
        .c4 { flex: 0 0 100%; max-width: 100%; }
        .box__address-text { padding-bottom: 50px; }
        .box__address { text-align: right; flex: auto; font-size: 14px; }
        .box__tarif { position: absolute; bottom: 5px; right: 10px; }
        .box__text { position: absolute; left: 10px; bottom: 5px; }
        .box__text span { font-size: 10px; }
        .box__tarif-barre { width: 100%; flex: 1; text-align: center; }
      }
    `,
  ];

  @property({ type: Object }) test: SarahTest | null = null;

  @state() private pulsing = false;

  private dispatchReserve(): void {
    if (!this.test) return;
    this.dispatchEvent(
      new CustomEvent('reserve', {
        detail: { id: this.test.id },
        bubbles: true,
        composed: true,
      }),
    );
    // Petite pulse sur le bouton "Réserver" pour confirmer visuellement que
    // toute la carte est cliquable.
    this.pulsing = true;
    window.setTimeout(() => {
      this.pulsing = false;
    }, 400);
  }

  private onCardClick(e: Event): void {
    // Évite la double-émission quand le clic vient déjà d'un lien interne
    // (ex: "Offre de remboursement").
    const target = e.target as HTMLElement | null;
    if (target && target.closest('a')) return;
    e.preventDefault();
    this.dispatchReserve();
  }

  private onCardKeydown(e: KeyboardEvent): void {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      this.dispatchReserve();
    }
  }

  private renderStateIcon(council: string) {
    return council === 'Complet' ? icon.close() : icon.warning();
  }

  render() {
    const t = this.test;
    if (!t) return nothing;
    const classes = [
      'box-resa-bis',
      'maxi',
      t.css || '',
      this.pulsing ? 'pulsing' : '',
    ]
      .filter(Boolean)
      .join(' ');

    const ariaLabel =
      `Réserver le test psychotechnique du ${t.date_mois_complet || ''}` +
      ` à ${t.ville || ''}, ${String(t.tarif_test ?? '')}€`;

    return html`
      <div
        class=${classes}
        role="button"
        tabindex="0"
        aria-label=${ariaLabel}
        @click=${this.onCardClick}
        @keydown=${this.onCardKeydown}
      >
        <div class="box__date-dept c1">
          <p class="box__date">
            <span>${t.date_day_week || ''}</span>${t.date_mois_complet || ''}
          </p>
          <div class="box__dept">
            <span class="box__dept-num">${t.num_departement || ''}</span>
            <span class="box__dept-ville">${t.ville || ''}</span>
          </div>
        </div>
        <div class="box__address-text c2">
          <div class="box__address">
            ${t.adresse || ''}, ${t.code_postal || ''} ${t.ville || ''}
          </div>
          <div class="box__text">
            <span class="state">
              <span class="ic" aria-hidden="true">${this.renderStateIcon(t.council || '')}</span>
              &nbsp;${t.council || ''}
            </span>
            <span class="free-cancel">
              <span class="ic" aria-hidden="true">${icon.check()}</span>
              &nbsp;Annulation Gratuite jusqu'à 48h
            </span>
          </div>
          <div class="box__tarif">
            <span class="apartir">À partir de</span>
            <span class="prix">
              ${String(t.tarif_test ?? '')}&nbsp;€${t.oldTarif
                ? html` <s>${String(t.oldTarif)}&nbsp;€</s>`
                : nothing}
            </span>
          </div>
          <span class="box__tarif-barre">
            <a
              href="https://www.aaaep.fr/aaaep/test-psychotechnique-pas-cher-offre-remboursement.html"
              target="_blank"
              rel="noopener"
              >Offre de remboursement de 50€</a
            >
          </span>
        </div>
        <div class="box__action c4">
          <button type="button" title="Dernières disponibilités" tabindex="-1">
            <span class="ic" aria-hidden="true">${icon.shoppingBasket()}</span>
            <span>${t.button || 'Réserver'}</span>
            ${t.button_left ? html`<span class="abs">${t.button_left}</span>` : nothing}
          </button>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sarah-box-test': SarahBoxTest;
  }
}
